export default class Logger {
  static log(...args) {
    if (window.PORTAL_STAGE !== 'prod') {
      window.console.log('AIM', ...args);
    }
  }

  static debug(...args) {
    if (window.PORTAL_STAGE !== 'prod') {
      window.console.debug('AIM', ...args);
    }
  }

  static error(...args) {
    window.console.error('AIM', ...args);
  }

  static info(...args) {
    if (window.PORTAL_STAGE !== 'prod') {
      window.console.info('AIM', ...args);
    }
  }

  static warn(...args) {
    if (window.PORTAL_STAGE !== 'prod') {
      window.console.warn('AIM', ...args);
    }
  }
}
